import Cookies from 'js-cookie';

export const VIDEO_CREATED_COOKIE = 'home_create_video_created';
export const CREATE_MOVED_DISMISSED_COOKIE = 'home_create_moved_callout_dismissed';
export const HOME_WELCOME_DISMISSED_MANUAL_COOKIE = 'home_create_welcome_dismissed_manual';

const ONE_YEAR = { expires: 365 };

export const hasCreatedVideoViaCreate = (): boolean => Boolean(Cookies.get(VIDEO_CREATED_COOKIE));

export const markVideoCreatedViaCreate = (): void => {
    Cookies.set(VIDEO_CREATED_COOKIE, '1', ONE_YEAR);
};

export const hasDismissedCreateMovedCallout = (): boolean =>
    Boolean(Cookies.get(CREATE_MOVED_DISMISSED_COOKIE));

export const dismissCreateMovedCallout = (): void => {
    Cookies.set(CREATE_MOVED_DISMISSED_COOKIE, '1', ONE_YEAR);
};

export const hasDismissedHomeWelcomeManually = (): boolean =>
    Boolean(Cookies.get(HOME_WELCOME_DISMISSED_MANUAL_COOKIE));

export const dismissHomeWelcomeManually = (): void => {
    Cookies.set(HOME_WELCOME_DISMISSED_MANUAL_COOKIE, '1', ONE_YEAR);
};
